import 'css-chunksrc/client/scenes/workloads/header/viewsSelector/styles.scss';export default {
  "viewsSelector": "_viewsSelector_pr40p_1",
  "input": "_input_pr40p_6",
  "icon": "_icon_pr40p_23",
  "list": "_list_pr40p_29",
  "item": "_item_pr40p_42",
  "open": "_open_pr40p_53"
};